import { createStyles, TextField, Theme, WithStyles, withStyles } from '@material-ui/core'
import React, { useState } from 'react'

interface OutcomeTextItemProps extends WithStyles<typeof styles> {
	label: string
	prop: string
	value: any
	placeholder?: string
	onInputChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
	required?: boolean
	fullWidth?: boolean
	hideUnknown?: boolean
	focus?: boolean
	items: any[]
	otherProps?: { [key: string]: any }
	labelStyle?: object
	dropDownStyle?: object
  serviceType?: string
}

const OutcomeTextItem: React.FC<OutcomeTextItemProps> = (props: OutcomeTextItemProps) => {
	const {
		classes,
		fullWidth,
		hideUnknown,
		onInputChange,
		otherProps,
		label,
		placeholder,
		prop,
		required,
		value,
		items,
		focus,
		labelStyle,
		dropDownStyle,
	} = props
	const inputRef = React.useRef()

	React.useEffect(() => {
		if (focus) {
			// @ts-ignore
			inputRef.current!.focus()
		}
	}, [focus])

  React.useEffect(()=>{
    setStateItems([...items])
  },[items])
  
  const [stateItems,setStateItems] = useState(items)

	return (
		<div className={classes.root}>
			<div className={classes.label} style={labelStyle}>{label}&#58; { props.required === true && (<span className={classes.requiredField} >*</span> ) }</div>
			<div className={`${classes.dropDownWrapper} ${fullWidth ? classes.full : ''}`} style={dropDownStyle}>
				<TextField
					name={prop}
					select={true}
					className={classes.dropdown}
					value={value}
					onChange={onInputChange}
					autoFocus={true}
					SelectProps={{
						native: true,
						MenuProps: {
							className: classes.input,
						},
						inputProps: {
							className: classes.select,
							required,
							...otherProps,
							ref: inputRef,
						},
					}}
					placeholder={placeholder}
					margin="dense"
					variant="outlined"
					label={placeholder}
				>
					{(!hideUnknown || !value) && (
						<option value="" data-auto="unknown">
							{hideUnknown ? '' : 'Unknown'}
						</option>
					)}
					{stateItems.map((option: string) => (
						<option key={option} value={option} data-auto={option}>
							{option}
						</option>
					))}
				</TextField>
			</div>
		</div>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			flex: 1,
			alignItems: 'center',
			flexWrap: 'wrap',
		},
		dropdown: {
			display: 'flex',
			flex: 1,
		},
		input: {},
		label: {
			flexBasis: '25%',
			justifyContent: 'flex-end',
			display: 'flex',
			paddingRight: '8px',

			[theme.breakpoints.down('sm')]: {
				flexBasis: '100%',
				justifyContent: 'flex-start',
			},
		},
		dropDownWrapper: {
			flexBasis: '30%',
			[theme.breakpoints.down('sm')]: {
				flexBasis: '100%',
			},
		},
		select: {
			textOverflow: 'ellipsis',
			overflow: 'hidden',
			whiteSpace: 'nowrap',
		},
		full: {
			flexGrow: 1,
		},
    requiredField:{
      color:'red'
    }
	})

export default withStyles(styles)(OutcomeTextItem)
